<div class="container-fluid">
  <alert></alert>
  <div *ngIf="loading">
    <loading-spinner></loading-spinner>
  </div>
  <div class="card mx-auto mt-5 w-50" *ngIf="!loading && !actionCompleted">
    <div class="card-header">{{ 'organization.invitation.details' | translate }}</div>

    <div class="card-body" *ngIf="validToken">
      <h5 class="card-title">{{ 'organization.invitation.you_have_been_invited_to' | translate }} {{ details?.tenantName }}</h5>
      <p class="card-text">{{ 'organization.invitation.info' | translate }}</p>
    </div>

    <div class="card-body" *ngIf="!validToken">
      <h5 class="card-title">{{ 'organization.invitation.token_invalid_or_expired' | translate }}</h5>
    </div>

    <div class="card-footer text-center">
      <kupari-button *ngIf="validToken" type="button" [class]="'btn btn-sm btn-primary mx-1'" [text]="'organization.invitation.accept_invitation'" (click)="acceptInvitation()"></kupari-button>
      <kupari-button type="button" [class]="'btn btn-sm btn-secondary'" [text]="'organization.invitation.to_login_page'" (click)="goToLoginPage()"></kupari-button>
    </div>
  </div>

  <div class="card mx-auto mt-5 w-50" *ngIf="actionCompleted">
    <div class="card-header">{{ 'organization.invitation.details' | translate }}</div>

    <div class="card-body">
      <h5 class="card-title">{{ 'organization.invitation.success' | translate }}</h5>
      <p class="card-text">{{ 'organization.invitation.accepted_info' | translate:{tenant: details?.tenantName } }}</p>
    </div>

    <div class="card-footer text-center">
      <kupari-button type="button" [class]="'btn btn-sm btn-secondary'" [text]="'organization.invitation.to_login_page'" (click)="goToLoginPage()"></kupari-button>
    </div>

  </div>



</div>
